import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./labeledValue.html";
/** Presentational title/content row (dl/dt/dd). No store subscriptions; usable inside or outside a card. */
class LabeledValue extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = '';
    this.contentAriaLabel = null;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LabeledValue, {
  publicProps: {
    title: {
      config: 0
    },
    contentAriaLabel: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(LabeledValue, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;